<template>

    <div class="panel-wrapper">

        <!-- HEADER -->
        <div class="header" :style="{ backgroundColor: cssPropColor('$color-primary') }">
            <span class="icon">
                <label @click="closePanel($event)" for="panel-toggle" title="Close"><i class="icon-MBR_close" aria-hidden="true"></i></label>
            </span>
            <span class="label" v-html="contact.form_label"></span>
        </div>
        <!-- END HEADER -->

        <!-- CONTENT -->
        <div class="panel-content" data-simplebar>

            <!-- BODY -->
            <div class="body">
                <div class="inner">

                    <div class="form-wrapper">

                        <h3 class="heading" v-html="contact.form_header" :style="{ color: cssPropColor('$color-primary') }"></h3>
                        <div class="copy" v-html="contact.form_intro" v-if="contact.form_intro"></div>
                        <div class="name" v-html="contact.name" v-if="(contact.name && contact.show_company_name)"></div>
                        <div class="address" v-if="contact.address1">
                            <div v-html="contact.address1"></div>
                            <div v-html="contact.address2" v-if="contact.address2"></div>
                            <div v-html="(contact.city + ', ' + contact.state + ' ' + contact.zipcode)" v-if="contact.city"></div>
                        </div>
                        <div class="phone" v-html="(((contact.fax) ? '(P) ' : '') + contact.phone)" v-if="contact.phone"></div>
                        <div class="fax" v-html="(((contact.phone) ? '(F) ' : '') + contact.fax)" v-if="contact.fax"></div>
                        <div class="email" v-if="contact.email">
                            <a :href="'mailto:' + (contact.email)" v-if="isContactEmail(contact.email)" :style="{ color: cssPropColor('$color-primary') }">{{ contact.email }}</a>
                            <a :href="contact.email" v-if="!isContactEmail(contact.email)" :style="{ color: cssPropColor('$color-primary') }" target="_blank">{{ contactUrlLabel }}</a>
                        </div>

                        <!--transition-group
                            name="fade"
                            mode="out-in"
                            tag="div"-->

                            <!-- FORM A -->
                            <div v-if="!submitted" key="contact-form-a">
                                <form id="contact-form-a" name="contact-form-a" method="post" v-if="hasContactFields" v-on:submit.prevent="handleFormSubmit">
                                    <div class="required-note">*Required</div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('fullname')">
                                        <input type="text" id="fullname" name="fullname" :placeholder="(contactFieldLabelBySlug('fullname'))" tabindex="1" v-if="contactFieldRequiredBySlug('fullname')" required />
                                        <input type="text" id="fullname" name="fullname" :placeholder="(contactFieldLabelBySlug('fullname'))" tabindex="1" v-if="!contactFieldRequiredBySlug('fullname')" />
                                    </div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('address-1')">
                                        <input type="text" id="address-1" name="address-1" :placeholder="(contactFieldLabelBySlug('address-1'))" tabindex="5" v-if="contactFieldRequiredBySlug('address-1')" required />
                                        <input type="text" id="address-1" name="address-1" :placeholder="(contactFieldLabelBySlug('address-1'))" tabindex="5" v-if="!contactFieldRequiredBySlug('address-1')" />
                                    </div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('address-2')">
                                        <input type="text" id="address-2" name="address-2" :placeholder="(contactFieldLabelBySlug('address-2'))" tabindex="10" v-if="contactFieldRequiredBySlug('address-2')" required />
                                        <input type="text" id="address-2" name="address-2" :placeholder="(contactFieldLabelBySlug('address-2'))" tabindex="10" v-if="!contactFieldRequiredBySlug('address-2')" />
                                    </div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('city')">
                                        <input type="text" id="city" name="city" :placeholder="(contactFieldLabelBySlug('city'))" tabindex="15" v-if="contactFieldRequiredBySlug('city')" required />
                                        <input type="text" id="city" name="city" :placeholder="(contactFieldLabelBySlug('city'))" tabindex="15" v-if="!contactFieldRequiredBySlug('city')" />
                                    </div>
                                    <div class="form-row" v-if="(contactFieldVisibleBySlug('state') || contactFieldVisibleBySlug('zipcode'))">
                                        <select name="state" tabindex="20" class="flex-50" v-if="contactFieldVisibleBySlug('state') && contactFieldRequiredBySlug('state')" required>
                                            <option value="">{{ stateProvinceLabel }}*</option>
                                            <option v-for="option in stateProvinceOptions[form.country]" :value="option.code">{{ option.name }}</option>
                                        </select>
                                        <select name="state" tabindex="20" class="flex-50" v-if="contactFieldVisibleBySlug('state') && !contactFieldRequiredBySlug('state')">
                                            <option value="">{{ stateProvinceLabel }}</option>
                                            <option v-for="option in stateProvinceOptions[form.country]" :value="option.code">{{ option.name }}</option>
                                        </select>
                                        <input type="text" id="zipcode" name="zipcode" class="flex-50" value="" :placeholder="(contactFieldLabelBySlug('zipcode'))" tabindex="25" v-if="contactFieldVisibleBySlug('zipcode') && contactFieldRequiredBySlug('zipcode')" required />
                                        <input type="text" id="zipcode" name="zipcode" class="flex-50" value="" :placeholder="(contactFieldLabelBySlug('zipcode'))" tabindex="25" v-if="contactFieldVisibleBySlug('zipcode') && !contactFieldRequiredBySlug('zipcode')" />
                                    </div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('country')">
                                        <select v-model="form.country" id="country" name="country" tabindex="30" v-if="contactFieldRequiredBySlug('country')" required>
                                            <option value="US" selected>United States</option>
                                            <option value="CA">Canada</option>
                                        </select>
                                        <select v-model="form.country" id="country" name="country" tabindex="30" v-if="!contactFieldRequiredBySlug('country')">
                                            <option value="US" selected>United States</option>
                                            <option value="CA">Canada</option>
                                        </select>
                                    </div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('phone')">
                                        <input type="tel" id="phone" name="phone" :placeholder="(contactFieldLabelBySlug('phone'))" tabindex="35" v-if="contactFieldRequiredBySlug('phone')" required />
                                        <input type="tel" id="phone" name="phone" :placeholder="(contactFieldLabelBySlug('phone'))" tabindex="35" v-if="!contactFieldRequiredBySlug('phone')" />
                                    </div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('email')">
                                        <input type="email" id="email" name="email" :placeholder="(contactFieldLabelBySlug('email'))" tabindex="40" v-if="contactFieldRequiredBySlug('email')" required />
                                        <input type="email" id="email" name="email" :placeholder="(contactFieldLabelBySlug('email'))" tabindex="40" v-if="!contactFieldRequiredBySlug('email')" />
                                    </div>
                                    <div class="form-row" v-if="(contact.form_type === 'sign-up' && contactFieldVisibleBySlug('policy-number'))">
                                        <input type="text" id="policy-number" name="policy-number" placeholder="Policy Number" tabindex="45" v-if="contactFieldRequiredBySlug('policy-number')" required />
                                        <input type="text" id="policy-number" name="policy-number" placeholder="Policy Number" tabindex="45" v-if="!contactFieldRequiredBySlug('policy-number')" />
                                    </div>
                                    <div class="form-row" v-if="contactFieldVisibleBySlug('contact-method')">
                                        <select id="contact-method" name="contact-method" tabindex="47" v-if="contactFieldRequiredBySlug('contact-method')" required>
                                            <option value="" v-html="(contactFieldLabelBySlug('contact-method'))"></option>
                                            <option value="Phone">Phone</option>
                                            <option value="Email">Email</option>
                                        </select>
                                        <select id="contact-method" name="contact-method" tabindex="47" v-if="!contactFieldRequiredBySlug('contact-method')">
                                            <option value="" v-html="(contactFieldLabelBySlug('contact-method'))"></option>
                                            <option value="Phone">Phone</option>
                                            <option value="Email">Email</option>
                                        </select>
                                    </div>
                                    <div class="form-row not-a-bot align-center justify-center">
                                        <input type="checkbox" name="not-a-bot" id="not-a-bot" tabindex="50" required /> <label for="not-a-bot">I am not a robot.*</label>
                                    </div>
                                    <div class="form-row align-center justify-center">
                                        <button type="submit" class="btn" tabindex="55" :disabled="submitting" :class="{ disabled: submitting }" :style="{ backgroundColor: cssPropColor('$color-secondary') }">Submit</button>
                                    </div>

                                    <transition name="fade" mode="out-in">
                                        <div class="form-row align-center justify-center" v-if="submitting">
                                            <span class="note">Transmitting your submission, please wait...</span>
                                        </div>
                                    </transition>

                                    <input type="hidden" id="company" name="company" :value="contact.slug" v-if="contact.slug" />
                                    <input type="hidden" id="form-type" name="form-type" :value="contact.form_type" v-if="contact.form_type" />

                                </form>
                            </div>
                            <!-- END FORM A -->

                        <!--/transition-group-->

                        <transition
                            name="fade"
                            mode="out-in">

                            <!-- THANKS -->
                            <div class="form-thanks" v-if="submitted" key="form-thanks">
                                <hr />
                                <h3 class="heading" v-html="contact.form_thanks_title"></h3>
                                <div class="copy" v-html="contact.form_thanks_msg" v-if="contact.form_thanks_msg"></div>
                            </div>
                            <!-- END THANKS -->

                        </transition>

                    </div>

                </div>
            </div>
            <!-- END BODY -->

        </div>
        <!-- END CONTENT -->

    </div>

</template>


<script>

    import { config } from '../config';

    let vm = {};

    export default {

        name: 'panel-content-contact',

        props: ['panel'],

        components: {},

        data() {
            return {
                submitted: false,
                submitting: false,
                form: {
                    country: 'US'
                },
                contactUrlLabel: 'Contact Us'
            }
        },

        computed: {

            contact() {
                return this.$dataStore.getters.getCompanyContactData;
            },

            hasContactFields() {
                return _.find(this.contact.form_fields, { visible: '1' });
            },

            stateProvinceOptions() {
                return {
                    'US': this.$dataStore.getters.getUSStateData,
                    'CA': this.$dataStore.getters.getCanadianProvinceData
                };
            },

            stateProvinceLabel() {
                return (this.form.country === 'US') ? 'State' : 'Province';
            }

        },

        created() {
            //console.info('%csidebar-content-contact::created', 'color:dodgerblue;');
        },

        mounted() {
            //console.info('%csidebar-content-contact::mounted', 'color:green;');

            vm = this;
        },

        methods: {

            isContactEmail(val) {
                let re = /(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))/;
                return re.test(val);
            },

            contactFieldTypeBySlug(slug) {
                let field = _.find(this.contact.form_fields, { 'slug': slug });
                return field.type;
            },

            contactFieldLabelBySlug(slug) {
                let field = _.find(this.contact.form_fields, { 'slug': slug });
                return field.label + (field.required === '1' ? '*' : '');
            },

            contactFieldRequiredBySlug(slug) {
                let field = _.find(this.contact.form_fields, { 'slug': slug });
                return (field.required === '1');
            },

            contactFieldVisibleBySlug(slug) {
                let field = _.find(this.contact.form_fields, { 'slug': slug });
                return (field.visible === '1');
            },

            handleFormSubmit(evt) {
                console.info('handleFormSubmit', evt);

                vm.submitting = true;

                // gather the form contents
                let _form           = $('#' + evt.target.id),
                    _formContents   = _form.serialize();

                // submit form data
                $.ajax({
                    url: config.formSubmitApi,
                    type: 'POST',
                    data: _formContents,
                    success: function(res) {

                        console.info('The form was successfully submitted.', res);

                        gtag('event', 'Contact Form Submission', {
                            'event_category': 'MBRe: Residential',
                            'event_label': ''
                        });

                        // reset form input
                        _form[0].reset();

                        // re-enable submit buttons & kill sending msg
                        vm.submitting = true;

                        // set form submitted to true, will trigger thank you msg.
                        vm.submitted = true;

                    },
                    error: function(xhr, status, err) {

                        console.error('There was an error submitting the form.', xhr, status, err);

                        // re-enable submit buttons & kill sending msg
                        vm.submitting = false;

                    }
                });
            },

            closePanel(evt){
                vm.$eventBus.$emit('residence:zoomout');
            },

            cssPropColor(colorProp) {
                if (window.CSS && window.CSS.supports && window.CSS.supports('(--foo: red)')) {
                    return;
                } else {
                    return (window.appTheme.colors[colorProp]) ? window.appTheme.colors[colorProp] : false;
                }
            }

        },

        events: {

        }

    }

</script>


<style lang="scss" scoped>

    @import '../assets/styles/helpers/variables';

    .panel-wrapper {
        height: 100%;
        position: relative;
        animation-duration: 0s;
        animation-delay: 0.6s;
        -webkit-touch-callout: default;
        user-select: auto;
    }

    .panel-content {

        & .body {
            padding: 30px 60px;
        }

        & h3 {
            position: relative;

            &::before {
                content: "\e903";
                font-family: 'icomoon' !important;
                font-size: 1.750rem;
                speak: none;
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                color: var(--color-primary);
                position: absolute;
                top: 50%;
                left: -43px;
                transform-origin: 50% 50%;
                transform: translateY(-50%);
            }
        }

        & .form-thanks {

            & h3 {

                &::before {
                    content: "\e901";
                    font-family: 'icomoon' !important;
                    font-size: 1.750rem;
                    speak: none;
                    font-style: normal;
                    font-weight: normal;
                    font-variant: normal;
                    text-transform: none;
                    color: var(--color-primary);
                }
            }
        }

        & .copy {
            margin: 0 0 16px 0;
        }

        & .name,
        & .address,
        & .phone,
        & .fax,
        & .email {
            margin: 0 0 3px 0;
        }
    }

    form {
        margin: 30px 0 0 0;
        display: flex;
        flex-flow: column nowrap;
        justify-content: space-between;

        -webkit-touch-callout: default;
        user-select: auto;

        & input:not([type="checkbox"]),
        & select {
            font-family: $font-univers-std;
            background-color: $white-100;
            font-size: 0.875rem;
            line-height: 26px;
            color: $form-text-color;
            width: 100%;
            height: 30px;
            margin: 0;
            padding: 0 10px;
            border: 1px solid $form-border-color;
            border-radius: 3px;
            box-shadow: inset 0 2px 3px $black-10;

            -webkit-touch-callout: default;
            user-select: auto;

            &:focus {
                outline: none;
                border-color: var(--color-focus);
                box-shadow: 0 0 10px var(--color-focus);
            }
        }

        & select {
            padding: 0 5px;
        }

        & input[type="checkbox"] {
            line-height: 1;
            vertical-align: middle;
            margin: 0 5px 0 0;
        }

        & .not-a-bot {
            margin: 5px 0 17px;
            display: block;

            & label {
                font-size: 0.750rem;
                line-height: 1;
                letter-spacing: initial;
                color: $form-note-text-color;
            }
        }

        & button {
            background-color: var(--color-secondary);

            &.disabled {
                opacity: 0.7;
                filter: grayscale(1);
            }
        }
    }

    .form-row {
        margin: 0 0 12px 0;
        display: flex;
        flex-flow: row nowrap;

        & input,
        & select {
            flex: 1 1 auto;

            &.flex-50 {
                flex: 1 1 50%;

                & ~ input,
                & ~ select {
                    margin-left: 10px;
                }
            }
        }
    }

    .note,
    .required-note {
        font-family: $font-univers-std;
        font-size: 0.688rem;
        line-height: 1;
        color: var(--color-base-text);
        text-align: center;
        margin: 0 0 8px 0;
    }

</style>


// WEBPACK FOOTER //
// PanelContentContact.vue?e49097ac